import React from "react";

//Ripped off: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
export default class ErrorBoundary extends React.Component {
   constructor(props) {
      super(props);
      this.state = { hasError: false };
   }

   static getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
   }

   componentDidCatch(error, info) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      console.error("Error Boundary Error Message: \n" + error);
      console.error("Error Boundary Stack Trace: \n" + info.componentStack);
      //remove license from localStorage
      localStorage.removeItem("license");
      //remove credentials from sessionStorage
      sessionStorage.clear();
      // Remove any lingering divs that might have been left in the DOM
      const appContainer = document.querySelector(
         ".universal-height-width-container",
      );
      if (appContainer) {
         for (const node of appContainer.childNodes) {
            if (
               node.nodeName === "DIV" &&
               !node.classList.contains("utility-wrapper")
            ) {
               node.remove();
            }
         }
      }
   }

   render() {
      if (this.state.hasError) {
         // You can render any custom fallback UI
         return this.props.fallback;
      }

      return this.props.children;
   }
}
